import { render, staticRenderFns } from "./PricingForm.vue?vue&type=template&id=13c522da&"
import script from "./PricingForm.vue?vue&type=script&lang=js&"
export * from "./PricingForm.vue?vue&type=script&lang=js&"
import style0 from "./PricingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports